import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Zap, Globe, Shield, Clock } from 'lucide-react'

const About: React.FC = () => {
  const { t } = useTranslation()

  const features = [
    {
      icon: Zap,
      titleKey: 'aboutFeature1Title',
      descKey: 'aboutFeature1Desc'
    },
    {
      icon: Globe,
      titleKey: 'aboutFeature2Title',
      descKey: 'aboutFeature2Desc'
    },
    {
      icon: Shield,
      titleKey: 'aboutFeature3Title',
      descKey: 'aboutFeature3Desc'
    },
    {
      icon: Clock,
      titleKey: 'aboutFeature4Title',
      descKey: 'aboutFeature4Desc'
    }
  ]

  return (
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-apple-gray-900 mb-6">
          {t('aboutTitle')}
        </h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-apple-gray-600 text-lg leading-relaxed mb-8">
            {t('aboutIntro')}
          </p>

          <h2 className="text-2xl font-semibold text-apple-gray-900 mt-10 mb-6">
            {t('aboutHowItWorks')}
          </h2>
          <p className="text-apple-gray-600 leading-relaxed mb-6">
            {t('aboutHowItWorksDesc')}
          </p>

          <div className="grid md:grid-cols-2 gap-6 my-10">
            {features.map((feature, index) => (
              <motion.div
                key={feature.titleKey}
                className="bg-apple-gray-50 rounded-2xl p-6 border border-apple-gray-100"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-apple-blue rounded-xl flex items-center justify-center mr-4">
                    <feature.icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-apple-gray-900">
                    {t(feature.titleKey)}
                  </h3>
                </div>
                <p className="text-apple-gray-600 text-sm leading-relaxed">
                  {t(feature.descKey)}
                </p>
              </motion.div>
            ))}
          </div>

          <h2 className="text-2xl font-semibold text-apple-gray-900 mt-10 mb-6">
            {t('aboutWhyChoose')}
          </h2>
          <p className="text-apple-gray-600 leading-relaxed mb-6">
            {t('aboutWhyChooseDesc')}
          </p>

          <h2 className="text-2xl font-semibold text-apple-gray-900 mt-10 mb-6">
            {t('aboutTechnology')}
          </h2>
          <p className="text-apple-gray-600 leading-relaxed">
            {t('aboutTechnologyDesc')}
          </p>
        </div>
      </motion.div>
    </div>
  )
}

export default About




